import React from 'react';
import PropTypes from 'prop-types';
import {Modal} from '@learningblocks/storybook-components';
import {Wrapper} from './Wrapper';
import {HeaderBlock} from './HeaderBlock';
import {ContentBlock} from './ContentBlock';
import './style.scss';
import {DoneButton} from './DoneButton';

export function HeatBlockModal(props) {
  React.useEffect(() => {
    props.setTimeLeft(30);
    props.checkBalance();
  }, [props.temperature]);

  React.useEffect(() => {
    props.checkBalance();
  }, [props.currentTemp]);

  const className = `${props.className} heatBlockModal`;

  const onClose = () => {
    props.toggleModal(false);
  };

  return (
    <Modal
      isOpen={props.isModalOpen}
      close={onClose}
      closeButton={true}
      className={className}>
      <Wrapper>
        <HeaderBlock />
        <ContentBlock
          slots={props.slots}
          temperature={props.temperature}
          setTemperature={props.setTemperature}
          currentTemp={props.currentTemp}
          balance={props.balance}
        />
        <DoneButton
          isModalOpen={props.isModalOpen}
          toggleModal={props.toggleModal}
        />
      </Wrapper>
    </Modal>
  );
}

HeatBlockModal.propTypes = {
  /**
   * Modal window to open when clicking on the HeatBlock
   */
  isModalOpen: PropTypes.bool.isRequired,
  /**
   * Function to triger the modalwindow,to change the state 'isModalOpen'
   */
  toggleModal: PropTypes.func,
  /**
   * Slots are the array which represent the filing of tube
   */
  slots: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * It defines the number of slot in the heatblock
       */
      slotId: PropTypes.number.isRequired,
      /**
       * It defines the number of slot in the heatblock
       */
      tube: PropTypes.bool,
    })
  ).isRequired,
  /**
   * State to store the setTemperature value
   */
  temperature: PropTypes.number,
  /**
   * Set temperature is a function to change the set Temperature
   */
  setTemperature: PropTypes.func,
  /**
   * State to store the currentTemp value
   */
  currentTemp: PropTypes.number,
  /**
   * It denotes the current temperature and the setTemperature is equal or not
   */
  balance: PropTypes.bool,
  /**
   * It is a function used to change the current temperature to set
   * temperature after 30 seconds
   */
  temperatureBalance: PropTypes.func,
  /**
   * Function to triggers to check the balance of the heat block
   */
  checkBalance: PropTypes.func,
  /**
   * Function to set timer
   */
  setTimeLeft: PropTypes.func,
};
